import React, { useState } from 'react';
import Modal from "react-bootstrap/Modal";
import { Card, CardBody } from '../../components/card/card';

const ModalComponent = ({ cardBodyContent }) => {
  const [fullscreen, setFullscreen] = useState(true);
  const [show, setShow] = useState(false);

  function handleShow(breakpoint) {
    setFullscreen(breakpoint);
    setShow(true);
  }

  return (
    <>
      <a
        href="#/"
        onClick={() => handleShow(true)}
        className="text-inverse text-opacity-50 text-decoration-none"
      >
        <i className="bi bi-fullscreen"></i>
      </a>

      <Modal
        show={show}
        fullscreen={fullscreen}
        onHide={() => setShow(false)}
        scrollable                  // ← add this
        className="custom-modal"    // ← add a custom class
      >
        <Modal.Header closeButton>
          <Modal.Title>BARSYS</Modal.Title>
        </Modal.Header>

        <Modal.Body className="p-0">
          <div 
            style={{
              maxHeight: '75vh',    // cap body to 75% of viewport height
              overflowY: 'auto'     // allow vertical scrolling
            }}
          >
            <Card className="m-0">
              <CardBody className="p-3">
                {cardBodyContent}
              </CardBody>
            </Card>
          </div>
        </Modal.Body>

      </Modal>
    </>
  );
};

export {ModalComponent};
